import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase env vars. Check .env.local');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export type Entitlement = {
  user_id: string;
  plan: 'free' | 'paid';
  status: 'active' | 'cancelled' | 'past_due' | 'inactive';
  free_used: number;
  paid_used_this_period: number;
  period_start: string | null;
  period_end: string | null;
  paddle_subscription_id: string | null;
  paddle_customer_id: string | null;
  updated_at: string;
};